export { ModalComponent } from './modal.component';